module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00092-fs8.43db032.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00092-fs8.png
// module id = 245
// module chunks = 0